module.exports = __webpack_public_path__ + "static/media/cloud-delete.46f0a47c.svg";